import React from 'react';
import {ServicesData} from 'models/app';

export interface ServicesDataTransformed extends ServicesData {
    icons: Record<string, string | null>;
}
export default React.createContext<ServicesDataTransformed>({
    dataByCategory: {},
    categories: [],
    products: {},
    icons: {},
});
